import EventEmitter from 'events'

export const Bus = new EventEmitter()

export enum Events {
  OpenPangram = 'pangram:open',
}

Bus.setMaxListeners(Infinity)
